import React from 'react';
import { View, Text, Button } from '@upstox/upstox-ui';
// store
import { useStore } from 'modules/Stores';
import { observer } from 'mobx-react';
// modules
import { ReleaseNotesIndicatorStates } from 'modules/App';
// utils
import { updateWhatsNewIndicatorStatusInLS } from 'utils/helpers/whatsNewUtils';
// constants
import { CHART_SYNC_DISCLAIMER_CONTENT } from './constants';
// styles
import * as css from './styles';

const ChartSyncDisclaimerModal = () => {
  const {
    toggleModal,
    modalsConfig: { chartSyncDisclaimer },
    releaseNotesIndicatorState,
    setReleaseNotesIndicatorState,
  } = useStore('AppStore');

  const handleAction = () => {
    setReleaseNotesIndicatorState(ReleaseNotesIndicatorStates.RELEASE_NOTES);
    updateWhatsNewIndicatorStatusInLS();
    toggleModal('chartSyncDisclaimer');
    // Show Whats New sidebar after the modal, only if it's not the first time intimation
    if (
      releaseNotesIndicatorState !== ReleaseNotesIndicatorStates.NEW_INTIMATION
    ) {
      toggleModal('releaseNotes');
    }
  };

  const getContent = () => {
    const {
      title,
      description,
      featuresTitle,
      featuresDescription,
      features,
      benefitsTitle,
      benefits,
      instructions,
    } = CHART_SYNC_DISCLAIMER_CONTENT;
    return (
      <View css={css.contentContainer}>
        <Text size="m" weight="bold" lineHeight="heading3">
          {title}
        </Text>
        {description}
        <Text size="m" weight="bold" lineHeight="heading3">
          {featuresTitle}
        </Text>
        {featuresDescription}
        <ol>
          {features.map(feature => (
            <li key={feature}>{feature}</li>
          ))}
        </ol>
        <Text size="m" weight="bold" lineHeight="heading3">
          {benefitsTitle}
        </Text>
        <ol>
          {benefits.map(benefit => (
            <li key={benefit}>{benefit}</li>
          ))}
        </ol>
        {instructions}
      </View>
    );
  };

  return chartSyncDisclaimer ? (
    <View css={css.modalContainer}>
      <View css={css.modalDialog}>
        <View flexDirection="column" css={css.base}>
          <View css={css.modalHeader}>Important update</View>
          <View css={css.modalBody}>{getContent()}</View>
          <View css={css.modalFooter}>
            <View
              flex
              justifyContent="space-evenly"
              alignItems="center"
              gap="medium"
            >
              <Button
                onClick={handleAction}
                style={{
                  height: '38px',
                  width: '100%',
                }}
                variant="primary"
                autoFocus
              >
                Okay, I understand
              </Button>
            </View>
          </View>
        </View>
      </View>
    </View>
  ) : null;
};

export default observer(ChartSyncDisclaimerModal);
